<!--DeFi借幣-->
<template>
	<div class="page-body center-wrap">
		<div class="defi-title">{{ $t('DeFi借币') }}</div>

		<div class="top-card dis-fle">
			<div class="left-con">
				<h3 class="white-color-text">{{ $t('助您探索更多交易机会和金融产品') }}</h3>
				<div class="learn hand">{{ $t('了解什么是DeFi借币') }}</div>
				<ul>
					<li>
						<img src="@/assets/img-pc/46.fdb9a03b.svg">
						<span>{{ $t('迅速到账，年化利率低至1%') }}</span>
					</li>
					<li>
						<img src="@/assets/img-pc/47.e2841bc0.svg">
						<span>{{ $t('可选多时间质押') }}</span>
					</li>
					<li>
						<img src="@/assets/img-pc/48.a7d25f2a.svg">
						<span>{{ $t('随时还款，提前还款减利息') }}</span>
					</li>
				</ul>
			</div>


			<rightModel @submit="initList"></rightModel>
		</div>

		<listModel ref="listModelRef"></listModel>
	</div>
</template>
<script>
import listModel from './components/list.vue';
import rightModel from './components/right.vue';
export default {
	components: {
		listModel,
		rightModel
	},
	data() {
		return {};
	},
	mounted() {

	},
	beforeUnmount() { },
	methods: {
		initList() {
			this.$refs.listModel.init()
		}
	},
};
</script>
<style lang="scss" scoped>
.left-con {
	width: 804px;
	height: 651px;
	box-shadow: 0 0 10px rgba(0, 0, 0, .10196078431372549);
	border-radius: 8px;
	background: url('~@/assets/img-pc/117.d2b095c5.png') no-repeat;
	background-size: cover;

	ul {
		width: 623px;
		margin: 100px auto 0;

		li {
			margin-top: 20px;
			font-size: 26px;
			display: flex;
			align-items: center;

			img {
				margin-right: 5px;
			}
		}
	}

	.learn {
		width: 338px;
		height: 56px;
		line-height: 56px;
		text-align: center;
		border-radius: 99px;
		border: 1px solid #84849f;
		background: #000;
		margin: 100px auto;
		color: #fff;
		font-size: 18px;
	}

	.white-color-text {
		width: 623px;
		margin: 50px auto;
		font-size: 30px;
		font-weight: 500;
	}
}

.defi-title {
	padding: 25px 0;
	font-size: 24px;
}
</style>